<mat-card>
  <input
    required="required"
    type="text"
    placeholder="Select Material"
    aria-label="Material Selection"
    matInput
    [(ngModel)]="setting.value"
    (ngModelChange)="onSearchTextChanged($event)"
    [matAutocomplete]="materialAutoComplete">
  <mat-autocomplete
    #materialAutoComplete="matAutocomplete"
    autoActiveFirstOption
    [displayWith]="displayMaterialName">
    <mat-option *ngFor="let option of options; trackBy: getIdentifierForIterableItem" [value]="option"
                (onSelectionChange)="onOptionsChanged(option)">
      <span>{{ option.number + ' - ' + option.name }}</span>
    </mat-option>
  </mat-autocomplete>
</mat-card>

